import {
  type APIError,
  type PreferenceGetInput,
  type PreferenceGetSuccess,
  type UnsavedView,
  type ViewAddInput,
  type ViewAddSuccess,
  type ViewData,
} from '@terros/common'
import { useMutation } from '@tanstack/react-query'
import { mutationAdd, type AddHookResponse } from '../hooks'
import { useServerRequest } from '../api'
import { getViewOrderPreference, type ViewOrderPreference } from './orderPreference'
import { useViewCache } from './cache'

export function useAddView(): AddHookResponse<UnsavedView, ViewData> {
  const cache = useViewCache()
  const addRequest = useServerRequest<ViewAddInput, ViewAddSuccess>('/view/add')
  const getOrder = useServerRequest<PreferenceGetInput<ViewOrderPreference>, PreferenceGetSuccess<ViewOrderPreference>>(
    '/preference/get'
  )

  async function add(view: UnsavedView): Promise<ViewData> {
    const preference = getViewOrderPreference(view.surface)
    const { value: order } = await getOrder({ preference })
    const output = await addRequest({ view })
    await cache.set(output.view, order)
    return output.view
  }

  const mutation = useMutation<ViewData, APIError, UnsavedView>({ mutationFn: add })
  return mutationAdd(mutation, mutation.mutateAsync)
}
